/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/*!***************************************!*\
  !*** ./src/assets/js/product-list.js ***!
  \***************************************/
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(fn) { try { return Function.toString.call(fn).indexOf("[native code]") !== -1; } catch (e) { return typeof fn === "function"; } }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var ProductSlider = /*#__PURE__*/function (_HTMLElement) {
  function ProductSlider() {
    var _this;
    _classCallCheck(this, ProductSlider);
    _this = _callSuper(this, ProductSlider);
    _this.slider = _this.querySelector('.swiper');
    _this.prevButton = _this.querySelector('.product-list-button-prev');
    _this.nextButton = _this.querySelector('.product-list-button-next');
    _this.paginaton = _this.querySelector('.product-list-pagination');
    return _this;
  }
  _inherits(ProductSlider, _HTMLElement);
  return _createClass(ProductSlider, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.init();
    }
  }, {
    key: "initSlider",
    value: function initSlider() {
      var _this2 = this;
      // Get the number of slides
      var slideCount = this.querySelectorAll('.swiper-slide').length;

      // Calculate offset to center slides when there are fewer than viewport
      var calculateOffset = function calculateOffset(breakpointSlides) {
        if (slideCount <= breakpointSlides) {
          // Calculate the space needed to center the slides
          var containerWidth = _this2.slider.offsetWidth;
          var slideWidth = (containerWidth - (breakpointSlides - 1) * 25) / breakpointSlides; // 25 is spaceBetween
          var totalSlidesWidth = slideCount * slideWidth + (slideCount - 1) * 25;
          return (containerWidth - totalSlidesWidth) / 2;
        }
        return 0;
      };
      this.activeSlider = new Swiper(this.slider, {
        slidesPerView: 1.2,
        spaceBetween: 25,
        centeredSlides: true,
        centeredSlidesBounds: true,
        loop: false,
        navigation: {
          nextEl: this.nextButton,
          prevEl: this.prevButton
        },
        pagination: {
          el: this.paginaton,
          type: 'bullets'
        },
        slidesOffsetAfter: 15,
        slidesOffsetBefore: 15,
        breakpoints: {
          580: {
            slidesPerView: 1.3,
            slidesOffsetAfter: 15,
            slidesOffsetBefore: 15
          },
          768: {
            slidesPerView: 2,
            slidesOffsetAfter: 0,
            slidesOffsetBefore: calculateOffset(2)
          },
          1024: {
            slidesPerView: 3,
            slidesOffsetAfter: 0,
            slidesOffsetBefore: calculateOffset(3)
          },
          1600: {
            slidesPerView: 4,
            slidesOffsetAfter: 0,
            slidesOffsetBefore: calculateOffset(4)
          }
        }
      });
    }
  }, {
    key: "init",
    value: function init() {
      var _this3 = this;
      var checkSwiper = setInterval(function () {
        if (typeof Swiper !== 'undefined') {
          _this3.initSlider();
          clearInterval(checkSwiper);
        }
      }, 100);
    }
  }]);
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get('product-list-slider')) {
  customElements.define('product-list-slider', ProductSlider);
}
/******/ })()
;